import { StatoAttoEnum } from "../enum/stato-atto-enum";
import { TipoAttoEnum } from "../enum/tipo-atto-enum";
import { TipologiaDecretoEnum } from "../enum/tipologia-decreto-enum";
import { DatiContabiliVO } from "./dati-contabiliVO";
import { DocumentoVO } from "./documentoVO";
import { MetadatiRepertorioVO } from "./metadati-repertorioVO";
import { SettoreVO } from "./settoreVO";
import { UtenteVO } from "./utenteVO";
import { VisibilitaAttoVO } from "./visibilita-attoVO";


export class AttoVO {
    id: string;
    nome: string;
    descrizione: string;
    oggetto: string;
    tipo: TipoAttoEnum;
    redattore: UtenteVO;
    settore: SettoreVO;
    decretoProgrammazione: Boolean;
    datiContabili: DatiContabiliVO[];
    tipologiaDecreto: TipologiaDecretoEnum;
    pubblicabile: boolean;
    responsabile: UtenteVO;
    stato: StatoAttoEnum;
    primario: DocumentoVO;
    contenutoAtto: string;
    allegati: DocumentoVO[];
    visibilitaAtto: VisibilitaAttoVO[];
    dataUltimaModifica: string;
    rimandato: Boolean;
    dataInserimento: string;
    dataConclusione: string;
    motivoStato: string;
    isSelected: boolean;
    checked: boolean;
    metadatiRepertorio: MetadatiRepertorioVO;
    progressivo: number;
    relazioneVerificatore: DocumentoVO;
    ordinario: boolean;
    riservato: boolean;


}

